import { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import MarkdownIt from 'markdown-it';
import markdownItModifyToken from 'markdown-it-modify-token';
import './tournament-dialog.css';

import { getRoomList } from '../../../modules/restore_together';
import { modifyToken } from '../../../services/utils/modifyToken';

import TournamentLeaderboard from './tournament-leaderboard';
import RoomCard from '../online-room-list/room_card';

const mdParser = new MarkdownIt({ typographer: true, modifyToken });
mdParser.use(markdownItModifyToken);

class TournamentDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      single_game_id: null,
      room: null,
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getRoomList());

    this.setRelevantRoom().then((room) => {
      this.setState({ ...this.state, room });
    });
  }

  checkIfHasHtmlTags(value) {
    return /<[a-z/][\s\S]*>/i.test(value);
  }

  playSingleGameTournament() {
    const { tournament_data } = this.props;
    this.setState({ ...this.state, single_game_id: tournament_data.game_id });
  }

  async setRelevantRoom() {
    const { tournament_data, roomList } = this.props;
    if (tournament_data.multiplayer) {
      for (const index in roomList) {
        const currentRoom = roomList[index];
        if (currentRoom.game_name === tournament_data.game_name) {
          return <RoomCard room_data={currentRoom} />;
        }
      }
    } else {
      const game_image = tournament_data.game_image
        ? tournament_data.game_image
        : `${tournament_data.game_name.toLowerCase().replaceAll(' ', '_')}.png`;
      const renderedImage = new URL(`../../../static/assets/game_icons/${game_image}`, import.meta.url).href;

      return (
        <div className="single_game_tournament_play_button" onClick={this.playSingleGameTournament.bind(this)}>
          <div className="single_game_tournament_play_text">Play Now</div>
          <img alt={`${tournament_data.game_name} icon`} src={renderedImage}></img>
        </div>
      );
    }
  }

  render() {
    const { tournament_data, show, hide_func, location } = this.props;
    const { room, single_game_id } = this.state;

    //const
    let messageContent = '';
    if (tournament_data.info) {
      messageContent = this.checkIfHasHtmlTags(tournament_data.info)
        ? tournament_data.info
        : mdParser.render(tournament_data.info);
    }

    const active = tournament_data.active;

    if (single_game_id) {
      return <Redirect to={{ pathname: `/play/tournament/${single_game_id}`, state: { from: location.pathname } }} />;
    } else if (show) {
      const logo_file_name =
        tournament_data.business_group_logo !== null ? tournament_data.business_group_logo : 'RESTORE-Logo.png';

      const logoSrc = new URL(`../../../static/assets/business_group_logos/${logo_file_name}`, import.meta.url).href;

      return (
        <div className="tournament_dialog_container">
          <div className="tournament_modal">
            <div className="tournament_dialog">
              <div className="tournament_dialog_close" onClick={hide_func}>
                X
              </div>
              <div id="tournament_dialog_title">{tournament_data.name} Leaderboard</div>
              <div className="tournament_dialog_content">
                <div className="tournament_dialog_half_content white">
                  <TournamentLeaderboard tournament_data={tournament_data} />
                </div>
                <div className="tournament_dialog_half_content">
                  <div id="tournament_logo_container">
                    <img
                      alt="tournament_business_group_logo"
                      className="tournament_business_group_logo"
                      src={logoSrc}
                    ></img>
                  </div>
                  <div id="tournament_info_container">
                    <div id="tournament_info" dangerouslySetInnerHTML={{ __html: messageContent }}></div>
                  </div>
                  {active && <div id="tournament_room_card_container">{room}</div>}

                  {!active && <div id="tournament_ended_message">This tournament has ended!</div>}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

const withState = connect((state) => {
  const { restoreTogether } = state;
  return {
    roomList: restoreTogether.roomList,
  };
});

export default withRouter(withState(TournamentDialog));
